<template>

    <b-container>

        <b-row>

            <!-- wizard-header>dasdasd</wizard-header -->
            <b-col lg="4"></b-col>
            <b-col lg="4">
                <br>
                <h1>Welcome to snap collective</h1>
                <br>
            </b-col>
            <b-col lg="4"></b-col>

        </b-row>


        <b-row>

            <b-col lg="4">

                <profile-widget></profile-widget>

            </b-col>



            <b-col lg="4">

                <brochure-widget-small></brochure-widget-small>

            </b-col>

            <b-col lg="4">

                <promotion-tips-small></promotion-tips-small>

            </b-col>    

        </b-row>




        <b-row>

<b-col lg="6" v-if="presaleBooks.length > 0">

<presale-results-small></presale-results-small>

</b-col>

<b-col lg="6" v-if="presaleBooks.length > 0">

<free-copies-widget></free-copies-widget>

</b-col>

</b-row>

        <!-- b-row>

            <b-col lg="12">

                <h1>Widgets for new books (2nd, 3rd etc open invitation)</h1>

            </b-col>

        </b-row -->

        <!-- b-row>

            <b-col lg="12" v-for="book in openBooks" :key="'one_open_'+book.photo_book.id">

                <profile-widget></profile-widget>

            </b-col>

        </b-row>

        <b-row>

            <b-col lg="12" v-for="book in openBooks" :key="'one_open_'+book.photo_book.id">

                <cover-preview></cover-preview>

            </b-col>

        </b-row -->

        <!-- b-row>
CHECK WHERE IS THIS
            <b-col lg="12" v-for="book in openBooks" :key="'one_open_'+book.photo_book.id">

                <presale-result></presale-result>

            </b-col>

        </b-row -->

        <b-row>

            <b-col lg="12" v-for="book in openBooks" :key="'one_open_'+book.photo_book.id">

                <new-photo-book-card :photoBookId="book.photo_book.id" v-if="activeBooksLoaded && (book.photo_book.state != 'presale_running')"></new-photo-book-card>

            </b-col>
        </b-row>

        <!-- b-row>

            <b-col lg="12">

                <h1>Widgets for active books (not added, finished or cancelled)</h1>

            </b-col>

        </b-row -->

        <b-row>

            <b-col lg="12" v-for="book in activeBooks" :key="'one_active_'+book.photo_book.id">

                <wizard-photo-book-card :photoBookId="book.photo_book.id" v-if="activeBooksLoaded && (book.photo_book.state != 'presale_running') && (book.photo_book.next_step < 7)"></wizard-photo-book-card>

            </b-col>

            <b-col lg="6" v-for="book in activeBooks" :key="'two_active_'+book.photo_book.id">

                <current-photo-book :photoBookId="book.photo_book.id" v-if="activeBooksLoaded && (book.photo_book.state != 'presale_running') && (book.photo_book.next_step > 6)"></current-photo-book>

            </b-col>

            <b-col lg="6" v-if="activeBooks.length > 1">

                <my-photo-books></my-photo-books>

            </b-col>

        </b-row>

        <!-- b-row>

            <b-col lg="4">

                <h1>Widgets for presale books (running)</h1>

            </b-col>
 
        </b-row -->
        <b-row v-if="presaleBooks.length > 0" v-for="book in presaleBooks" :key="'row_presale_'+book.photo_book.id">

            <b-col lg="12">

                <h1>Your art book in Pre-Order '{{book.photo_book.title}}'</h1>
            
            </b-col>

            <b-col lg="6">

                <presale-photo-book :photoBookId="book.photo_book.id" v-if="presaleBooksLoaded"></presale-photo-book>
                
            </b-col>

            <b-col lg="6">

                <mockups :photoBookId="book.photo_book.id" v-if="presaleBooksLoaded"></mockups>

                

            </b-col>

            <b-col lg="12">

                <presale-results :photoBookId="book.photo_book.id" v-if="presaleBooksLoaded"></presale-results>

            </b-col>

            

        </b-row>

<!--
    <b-row>
        <b-col lg="6">
            <promotion-tips></promotion-tips>
        </b-col>
        <b-col lg="6">
            <brochure-widget></brochure-widget>
        </b-col>
    </b-row>
-->
     


    </b-container>

</template>
<script>
import { mapGetters } from 'vuex'

import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import AppStyle from '@/plugins/appStyle';

import WizardHeader from '../Pages/PhotoBookWizard/WizardHeader';

import PromotionTips from '../cscomponents/artist/widgets/PromotionTips';
import Mockups from '../cscomponents/artist/widgets/Mockups';
import MyPhotoBooks from '../cscomponents/artist/widgets/MyPhotoBooks';
import CurrentPhotoBook from '../cscomponents/artist/widgets/CurrentPhotoBook';
import PresalePhotoBook from '../cscomponents/artist/widgets/PresalePhotoBook';
import WizardPhotoBookCard from '../cscomponents/artist/widgets/WizardPhotoBookCard';
import NewPhotoBookCard from '../cscomponents/artist/widgets/NewPhotoBookCard';
import ProfileWidget from '../cscomponents/artist/widgets/ProfileWidget';
import CoverPreview from '../cscomponents/artist/widgets/CoverPreview';
import PresaleResults from '../cscomponents/artist/widgets/PresaleResults';
import PresaleResultsSmall from '../cscomponents/artist/widgets/PresaleResultsSmall';
import BrochureWidget from '../cscomponents/artist/widgets/BrochureWidget';
import FreeCopiesWidget from '../cscomponents/artist/widgets/FreeCopiesWidget';

import PromotionTipsSmall from '../cscomponents/artist/widgets/PromotionTipsSmall';
import BrochureWidgetSmall from '../cscomponents/artist/widgets/BrochureWidgetSmall';
//import Mockups from '../cscomponents/artist/widgets/Mockups.vue';

export default {
    mixins: [AppStyle.Mixin],
    name: 'artist-dashboard',
    data() {
        return {
            loading: false,
            activeBooks: [],
            presaleBooks: [],
            openBooks: [],
        };
    },
    components: {
        RouteBreadCrumb,
        WizardHeader,
        PromotionTips,
        Mockups,
        MyPhotoBooks,
        CurrentPhotoBook,
        PresalePhotoBook,
        WizardPhotoBookCard,
        NewPhotoBookCard,
        ProfileWidget,
        CoverPreview,
        PresaleResults,
        PresaleResultsSmall,
        BrochureWidget,
        FreeCopiesWidget,
        BrochureWidgetSmall,
        PromotionTipsSmall,
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
        activeBooksLoaded: function () {
            return Array.isArray(this.activeBooks) && this.activeBooks.length >= 0;
        },
        presaleBooksLoaded: function () {
            return Array.isArray(this.presaleBooks) && this.presaleBooks.length >= 0;
        },
        openBooksLoaded: function () {
            return Array.isArray(this.openBooks) && this.openBooks.length >= 0;
        },
    },
    methods: {
        retrieveActiveBooks() {
            this.loading = true;
            this.activeBooks = [];
            this.$api.getActivePhotoBooks("")
                .then((response) => {
                    //console.log(response);
                    this.activeBooks = response.data.photo_books;
                    console.log(this.activeBooks);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
        },
        retrievePresaleBooks() {
            this.loading = true;
            this.presaleBooks = [];
            this.$api.getPresalePhotoBooks("")
                .then((response) => {
                    console.log(response);
                    this.presaleBooks = response.data.photo_books;
                    console.log(this.presaleBooks);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
        },
        retrieveOpenBooks() {
            this.loading = true;
            this.openBooks = [];
            this.$api.getOpenPhotoBooks("")
                .then((response) => {
                    //console.log(response);
                    this.openBooks = response.data.photo_books;
                    console.log(this.openBooks);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
        },
        formatDate(date) {
            return moment(date).format("Do MMM YYYY")
        },
        showPromotionTips(){

        }
    },
    mounted() {
        this.retrieveActiveBooks();
        this.retrievePresaleBooks();
        this.retrieveOpenBooks();
    },

};
</script>
<style>
.profile-header {
    background-image: url(/img/theme/profile-cover.jpg);
    background-size: cover;
    background-position: center top;
    min-height: 500px;
}
</style>